import './textbox.scss';
import React, {Component} from 'react';


class TextBox extends Component {

    inputMode = this.props.name === 'mobile' || this.props.name === 'code' ? 'numeric' : '';

    constructor(props) {
        super(props);
        this.onChangeValue = this.onChangeValue.bind(this);
        this.state = {
            errors: {},
            hints: {},
            direction: this.props.direction ?? "rtl"
        };
    }

    onChangeValue(e) {
        this.props.changeValue(e);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.errorData !== this.props.errorData) {
            this.handleErrorMsg();
        }
        if (prevProps.direction !== this.props.direction) {
            this.setState({direction: this.props.direction});
        }
    }

    handleErrorMsg() {
        this.setState({
            hints: this.props.errorData.hints,
            errors: this.props.errorData.errors,
            errorCounter: this.props.errorData.counter
        });
        this.setState({errorMsg: this.props.errorData.errors[this.props.name]})
    }

    render() {
        return (
            <label
                className={`textbox ${this.props.className} ${(this.state.errorCounter > 0 && this.state.errors[this.props.name] !== '' ? "textbox--error" : "")} ${this.state.direction}`} key={1}>

                {this.props.type !== 'textarea' ?
                <>
                    {this.props.showLabel &&
                    <span className={'textbox__title'} key={2}>{this.props.label}</span>
                    }
                    <input className={`${this.props?.disable ? "disabled":""}`}
                        onChange={this.onChangeValue}
                        id={this.props.id}
                        name={this.props.name}
                        type={this.props.type}
                        value={this.props.value}
                        disabled={this.props.disable}
                        placeholder={this.props.placeholder}
                        autoFocus={this.props.isAutoFocus}
                        inputMode={this.inputMode}
                        autoComplete={this.props.autoComplete}
                        ref={this.props.setRef}
                        spellCheck={this.props.spellCheck}
                        dir={this.state.direction}
                        key={3}
                        tabIndex={this.props.tabIndex}
                    />

                    {this.state.errorCounter > 0 && this.state.errors[this.props.name] !== '' && this.props.showMessage &&
                    <div className={'textbox__subtitle'} key={4}>
                        {this.state.hints[this.props.name] &&
                            <i className={'fa fa-light fa-circle-exclamation'} title={this.state.hints[this.props.name]}/>}
                        {this.state.errorMsg}
                    </div>}
                    {this.props?.errorMessages?.length > 0 && this.props.errorMessages.map((errorMessage, item) => <div className={'textbox__subtitle'} key={ 5+item }>
                        <i className={'fa fa-light fa-circle-exclamation'} />
                        {errorMessage}
                    </div>)}
                </>
                    :
                    <>
                        <textarea className={`${this.props?.disable ? "disabled":""}`}
                               style={{direction: this.state.direction, ...{...this.props.style}}}
                               id={this.props.id}
                               onChange={this.onChangeValue}
                               name={this.props.name}
                               type={this.props.type}
                               value={this.props.value}
                               disabled={this.props.disable}
                               placeholder={this.props.placeholder}
                               autoFocus={this.props.isAutoFocus}
                               inputMode={this.inputMode}
                               autoComplete={this.props.autoComplete}
                               ref={this.props.setRef}
	                           {...this.props.textConfigs}
                        />
                    </>
                }
            </label>
        );
    }
}


export default TextBox;